import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {  scroller } from 'react-scroll';
import './Navbar.css';
import doclivo from '../assets/doclivo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'; // Import icons


const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown
    const [specialtiesOpen, setSpecialtiesOpen] = useState(false); // State for sub-dropdown
    const [isMobile, setIsMobile] = useState(false);
    

    const location = useLocation(); //get current route

    useEffect(() => {
        const hash = location.hash.replace('#', '');
        if (hash) {
            scroller.scrollTo(hash, {
                duration: 1000,
                delay: 0,
                smooth: 'easeInOutQuart',
                offset: -70,
            });
        }
    }, [location]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    //toggle menu for small sccreens 
    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    //toggle dropdown for "who we're for" 
    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen); // Toggle dropdown open/close
    };

    // Toggle sub-dropdown for "For Specialties"
    const toggleSpecialties = () => {
        setSpecialtiesOpen(!specialtiesOpen); // Toggle sub-dropdown open/close
    };


    // Function to refresh the page when logo is clicked
    const refreshPage = () => {
        window.location.reload(); // Reload the entire page
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Logo */}
                <div className="logo">
                    {/* onClick triggers a full page reload */}
                    <a href="/" onClick={refreshPage} className="logo-link">
                        <img src={doclivo} alt="logo" className="logo-image" />
                    </a>
                </div>

                {/* Hamburger Icon */}
                <div className="menu-icon" onClick={toggleMenu} aria-label="Toggle navigation menu">
                    <FontAwesomeIcon icon={isOpen ? faTimes : faBars} /> {/* Use FontAwesome */}
                </div>

                {/* Navbar Links */}
                <ul className={isOpen ? "navbar-list dropdown-active" : "navbar-list"}>

                    {/* Dropdown for "Who we're for" */}
                    <li className="dropdown" onClick={isMobile ? toggleDropdown : null} onMouseEnter={!isMobile ? toggleDropdown : null} onMouseLeave={!isMobile ? toggleDropdown : null}>
                        <div className="dropdown-link">
                            Who we're for 
                        </div>
                        {dropdownOpen && (
                            <div className="dropdown-menu">
                                <div className="dropdown-column">
                                    <ul>
                                        <li><RouterLink to="/for-independent-practices">For Independent Practices</RouterLink></li>
                                        <li><RouterLink to="/for-new-practices">For New Practices</RouterLink></li>

                                        <li className="sub-dropdown" onClick={isMobile ? toggleSpecialties : null} onMouseEnter={!isMobile ? toggleSpecialties : null} onMouseLeave={!isMobile ? toggleSpecialties : null}>
                                            <RouterLink>For Specialties</RouterLink>
                                            {specialtiesOpen && (
                                                <ul className="sub-dropdown-menu">
                                                    <li><RouterLink to="/for-consultant-physicians">For Consultant Physicians</RouterLink></li>
                                                    <li><RouterLink to="/for-general-practitioners">For General Practitioners</RouterLink></li>
                                                    <li><RouterLink to="/for-dermatologists">For Dermatologists</RouterLink></li>
                                                </ul>
                                            )}
                                        </li>

                                        <li><RouterLink to="/for-ca">For CA's</RouterLink></li>
                                        <li><RouterLink to="/for-patients">For Patients</RouterLink></li>

                                    </ul>
                                </div>
                            </div>
                        )}
                    </li>


                    {/* Products */}
                    <li className="dropdown" onClick={isMobile ? toggleDropdown : null} onMouseEnter={!isMobile ? toggleDropdown : null} onMouseLeave={!isMobile ? toggleDropdown : null}>
                        <div className="dropdown-link">
                            Products
                        </div>
                        {dropdownOpen && (
                            <div className="dropdown-menu">
                                <div className="dropdown-column">
                                    <ul>
                                        <li><RouterLink to="/emr">EMR</RouterLink></li>
                                        <li><RouterLink to="/digital-footprint">Digital Footprint</RouterLink></li>
                                        <li><RouterLink to="/digital-outreach">Digital Outreach</RouterLink></li>
                                        <li><RouterLink to="/billing-and-payments">Billings & Payments</RouterLink></li>
                                        <li><RouterLink to="/data-and-insights">Data & Insights</RouterLink></li>
                                    </ul>
                                </div>
                            </div>
                        )}
                    </li>

                    {/* Home */}
                    {/*
                    <li>
                        {location.pathname === '/' ? (
                            <ScrollLink to="header" smooth={true} offset={-70} duration={1000} onClick={toggleMenu}>
                                Home
                            </ScrollLink>
                        ) : (
                            <RouterLink to="/#header">Home</RouterLink>  // Route to homepage if not on it
                        )}
                    </li>
                    */}


                    {/* Solutions */}
                    {/**
                    <li>
                        <ScrollLink to="solutions" smooth={true} offset={-70} duration={1000} onClick={toggleMenu}>
                            Solutions
                        </ScrollLink>
                    </li>
                    */}

                    {/* Why Doclivo */}
                    <li>
                        <a href="/about" onClick={refreshPage}>Why Doclivo</a>
                    </li>

                    
                    {/* contact */}
                    {/*
                    <li>
                        {location.pathname === '/' ? (
                            <ScrollLink to="ctaSection" smooth={true} offset={-70} duration={1000} onClick={toggleMenu}>
                                Contact
                            </ScrollLink>
                        ) : (
                            <RouterLink to="/#ctaSection">Contact</RouterLink>  // Route to homepage if not on it
                        )}
                    </li>
                     */}       

                    {  /* <li>
                        <RouterLink to="/faq">FAQ</RouterLink>
                    </li> */}

                </ul>

                {/* Right-aligned buttons */}
                <div className="navbar-buttons">

                    { /* <button className="navbar-button signin-btn">Sign-In</button> */}

                    
                        <RouterLink to="/demo" className="navbar-button demo-btn">Get Demo</RouterLink>
                   
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
